import {
  changeQuestionClearOnHide,
  getQuotationIsFromRenewal,
  setQuestionVisibility,
} from 'app/services/businessFunctionHelpers';

import { FieldsEnum, FormsEnum } from 'app/shared/enums';

const previousInsurer = {
  previousInsurerChange() {
    const isFromRenewal = getQuotationIsFromRenewal();

    if (isFromRenewal) {
      changeQuestionClearOnHide(
        FieldsEnum.CarPreviousInsurer,
        FormsEnum.CalculationForm,
        false
      );

      setQuestionVisibility({
        key: FieldsEnum.CarPreviousInsurer,
        visible: false,
        formName: FormsEnum.CalculationForm,
      });
    }
  },
};

export default previousInsurer;
